import fetch from '@adc/fetch'
import configment from '@adc/configment'

export const getCounties = async (req, searchVal) => {
  const res = await fetch(
    `${configment.get('PLATFORM_API_GLS_URL')}/gls/v1/counties`,
    {
      req,
      queryParams: {
        county_name: searchVal,
      },
    }
  )

  return res.body
}

export const getSuggestions = async (req, { text, fields }) => {
  const res = await getCounties(null, text)
  const counties = res.content.map(county => county.county_name)
  const suggestionsData = [
    {
      field: fields[0],
      values: counties,
    },
  ]

  return suggestionsData
}
